import { supabase } from '../lib/supabase';

export const APP_ONLINE_PRESENCE_CHANNEL = 'app-online-users';
export const CARD_GAME_FIND_OPPONENTS_PRESENCE_CHANNEL = 'card-game-find-opponents';

const ONLINE_WINDOW_MS = 2 * 60 * 1000;

const missingPresenceSchemaPatterns = [
    'schema cache',
    'does not exist',
    'Could not find the table',
    'relation "public.user_online_presence"',
];

const isMissingPresenceSchemaError = (error) => {
    const message = error?.message || '';
    return missingPresenceSchemaPatterns.some(pattern => message.includes(pattern));
};

export const getOnlineUserIdsFromPresenceState = (presenceState, excludeUserId) => {
    const onlineIds = new Set();

    Object.entries(presenceState || {}).forEach(([presenceKey, metas]) => {
        if (presenceKey && presenceKey !== excludeUserId) {
            onlineIds.add(presenceKey);
        }

        (metas || []).forEach(meta => {
            const userId = meta?.user_id || meta?.id;
            if (userId && userId !== excludeUserId) {
                onlineIds.add(userId);
            }
        });
    });

    return [...onlineIds];
};

export const mergeOnlineUserIds = (...idLists) => (
    [...new Set(
        idLists
            .flat()
            .filter(Boolean)
    )]
);

export const touchOnlinePresence = async (user, profile) => {
    if (!user?.id) return;

    try {
        const { error } = await supabase
            .from('user_online_presence')
            .upsert({
                user_id: user.id,
                username: profile?.username || profile?.nome || user.email?.split('@')?.[0] || 'usuario',
                last_seen_at: new Date().toISOString(),
            }, {
                onConflict: 'user_id',
            });

        if (error) throw error;
    } catch (error) {
        if (!isMissingPresenceSchemaError(error)) {
            console.error('[Presence] Erro ao atualizar heartbeat:', error.message);
        }
    }
};

export const getRecentlyOnlineUserIds = async (excludeUserId) => {
    try {
        const cutoff = new Date(Date.now() - ONLINE_WINDOW_MS).toISOString();
        let query = supabase
            .from('user_online_presence')
            .select('user_id')
            .gte('last_seen_at', cutoff);

        if (excludeUserId) {
            query = query.neq('user_id', excludeUserId);
        }

        const { data, error } = await query;
        if (error) throw error;

        return (data || []).map(item => item.user_id).filter(Boolean);
    } catch (error) {
        if (!isMissingPresenceSchemaError(error)) {
            console.error('[Presence] Erro ao buscar usuários online:', error.message);
        }
        return [];
    }
};
